import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

import { DistributionsService } from 'src/app/services/distributions.service';
import { InventoryService } from 'src/app/services/inventory.service';

import { firstValueFrom } from 'rxjs';
import Swal from 'sweetalert2';


@Component({
  selector: 'app-materials-settings',
  templateUrl: './materials-settings.component.html',
  styleUrls: ['./materials-settings.component.scss']
})
export class MaterialsSettingsComponent {
  // #region Variables
  batch: number = 0;
  dataMat: any;
  images: any;
  pesoUnitario: boolean = false;
  received!: number;
  tamanobatch: boolean = false;
  tipoRelleno: string = '';
  tipoSeleccionado: string = '';


  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private distributions: DistributionsService, private inventory: InventoryService) { }

  ngOnInit(): void {
    this.batch = this.data.batch;
    this.dataMat = this.data;
    this.images = this.data.imgs;
    this.received = this.data.recibido ?? 0;
    this.pesoUnitario = this.data.bitPesoUnitario;
    this.tamanobatch = this.data.bitTamanoBatch;

    if (this.data.bitPesoUnitario === 1) {
      this.tipoSeleccionado = 'peso';
      this.tipoRelleno = 'peso (kg)';
    } else if (this.dataMat.bitTamanoBatch === 1) {
      this.tipoSeleccionado = 'batch';
      this.tipoRelleno = this.batch == 1 ? 'unidad' : 'unidades';
    }

    if(this.batch == null){
      this.batch = 1;
    }
  }


  // #region Functions
  onTipoChange() {
    if (this.tipoSeleccionado === 'peso')
      this.tipoRelleno = 'peso (kg)';
    else
      this.tipoRelleno = 'unidades';
  }

  soloEnteros(event: any) {
    const value = event.target.value;
    event.target.value = value.replace(/[^0-9]/g, '');
    this.batch = event.target.value;
  }


  // #region Asyncs
  async saveSettings(): Promise<void> {
    console.log(this.received);

    if(this.tipoSeleccionado == 'peso') {
      this.pesoUnitario = true;
      this.tamanobatch = false;
    }
    
    if(this.tipoSeleccionado == 'batch') {
      this.tamanobatch = true;
      this.pesoUnitario = false;
    }

    let payload: any = {
      line: null,
      received: null
    };

    if (this.pesoUnitario || this.tamanobatch) {
      payload.line = {
        batch: this.batch == null ? 0 : this.batch,
        bitPesoUnitario: this.pesoUnitario == true ? 1 : 0,
        bitTamanoBatch: this.tamanobatch == true ? 1 : 0,
        id_mat_camp: this.data.id_mat_camp
      }
    }

    if (this.received !== (this.data.recibido ?? 0)) {
      payload.received = {
        bitSemaforo: this.data.campaign.bitSemaforo,
        campana: this.data.campaign,
        cantidad: this.received - this.data.recibido,
        id_camp: this.data.id_campana,
        id_mat: this.data.id,
        id: this.data.id_mat_camp,
        tipo: this.data.tipo
      }
    }

    if (this.batch != null && this.batch < 0) {
      Swal.fire({
        icon: 'warning',
        title: 'Atención',
        text: 'No se aceptan cantidades negativas'
      })
    } else {
      try {
        if (payload.line)
          await firstValueFrom(this.distributions.saveRellenoConf(payload.line));

        if (payload.received) {
          const result: any = await firstValueFrom(this.inventory.updateCantidadRecibida(payload.received));
          
          if (!result.message || result.message !== "Success")
            throw new Error(result.message ?? "Process error");
        }

        const objSendPeso = {
          peso: this.dataMat.peso,
          sku: this.data.sku,
          id_campana: this.data.id_campana
        }

        this.distributions.editPeso(objSendPeso).subscribe(
              (result: any) => {
                Swal.fire({
                  icon: 'success',
                  title: 'Guardado',
                  text: ''
                });
              },
              (err: any) => {
                console.log(err);
                Swal.fire({
                  icon: 'error',
                  title: 'Error al editar',
                  text: 'Ocurrió un error al editar'
                });
              }
          );

      } catch (error) {
        console.log(error);
        Swal.fire({
          icon: 'error',
          title: 'Error al guardar',
          text: 'Ocurrió un error al guardar'
        });
      }
    }
  }
}